module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_2_1-dabebbfc12be2160b99f93a8487792e7.svg";